import { Carousel, Slide } from "vue-carousel";
import { mapGetters } from "vuex";

export default {
    name: "CosmoBaseSlider",
    props: {},
    emits: [],
    components: { Carousel, Slide },
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
            content: "cosmobase/content",
        }),
    },
    methods: {}
}
